import React from 'react';
import axios from 'axios';
import authHeader from '../../helpers/getEmailHeader';

import { withTranslation } from 'react-i18next';

import NumberFormat from 'react-number-format';

import './FlowForm.scss';

class FlowForm extends React.Component {
  static emptyTimeout;
  static reAppearTimeout;

  constructor(props) {
    super(props)
    this.state = {
      number: '',
      error: '',
      isSent: false,
      isClosed: false,
      isScrolledTo: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.updateScroll);
  }

  componentWillUnmount() {
    clearTimeout(this.reAppearTimeout);
    clearTimeout(this.emptyTimeout);
    window.removeEventListener('scroll', this.updateScroll);
  }

  closeForm = () => {
    this.setState({
      isClosed: true
    })
    this.reAppearTimeout = setTimeout(() => {
      this.setState({
        isClosed: false
      })
    }, 60000)
  }

  updateScroll = () => {
    let currentScroll = window.pageYOffset;
    let pointToShowForm = this.props.showFormPoint;

    if (currentScroll >= pointToShowForm) {
      this.setState({
        isScrolledTo: true,
      })
    } else {
      this.setState({
        isScrolledTo: false,
      })
    }
  }

  handleChange = (event) => {
    this.setState({
      number: event.target.value,
      error: '',
      isSent: false
    })
  }

  checkNumber = () => {
    const { number } = this.state;

    if (number.trim().length >= 13) {
      return true;
    } else {
      return false;
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { number } = this.state;

    if (this.checkNumber()) {
      const api_url = process.env.REACT_APP_API_URL || 'https://edelivery-dev.os-system.com';

      try {
        const resp = axios.post(api_url + '/api/form', {
          phoneNumber: number,
          site: 'de',
        }, { headers: { ...authHeader() } });
        if (process.env.NODE_ENV !== 'production') {
          console.log(resp);
        }
      } catch (e) {
        console.log(e)
      };

      this.setState({
        error: '',
        isSent: true
      });

      this.emptyTimeout = setTimeout(() => {
        this.setState({
          number: '',
          isSent: false,
        })
      }, 20000);

    } else {
      this.setState({
        error: 'error'
      })
    }
  }

  render() {
    const { isSent, error, isClosed, isScrolledTo } = this.state;
    const { t } = this.props;

    if (isClosed || !isScrolledTo) {
      return null;
    }

    return (
      <div className={isSent ? 'flow-form-container isSent' : 'flow-form-container'} >
        <div className='flow-form-wrapper'>
          <span
            className='icon-cross'
            onClick={() => this.closeForm()}
          />
          <span className='form-title'>{isSent ? t('flow.formSent') : t('flow.formTitle')}</span>

          <form id='flow-form' onSubmit={this.handleSubmit}>
            <div className='flow-form-inner-container'>
              <div className='flow-input-container'>
                <NumberFormat
                  format='+49 #############'
                  className='flow-number-input'
                  allowEmptyFormatting
                  onChange={this.handleChange}
                  value={this.state.number}
                />
                {error && <span className='flow-error-message'>{t('flow.formError')}</span>}
              </div>
              <button type='submit' className='flow-form-btn'>{t('flow.formButton')}</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
};

export default withTranslation()(FlowForm);
